var conf = {
  "init": {
    "url": "user/init",
    "method": "get"
  },
  "get_userinfo": {
    "url": "user/get_userinfo",
    "method": "get"
  },
  "get_userinfo_batch": {
    "url": "user/get_user_info_batch",
    "method": "post"
  },
  "get_user_online_info": {
    "url": "user/get_user_online_info",
    "method": "get"
  },
  "get_users_online_info": {
    "url": "user/get_users_online_info",
    "method": "post"
  },
  "add_black_list": {
    "url": "user/add_black_list",
    "method": "get"
  },
  "del_black_list": {
    "url": "user/del_black_list",
    "method": "get"
  },
  "is_blacked": {
    "url": "user/is_blacked",
    "method": "get"
  },
  "msg_set": {
    "url": "user/msg_set",
    "method": "post"
  },
  "remark": {
    "url": "user/remark",
    "method": "post"
  },
  "sendmsg": {
    "url": "msg/sendmessage",
    "method": "post",
    "sign": true
  },
  "send_msg_js": {
    "url": "msg/send_msg_js",
    "method": "post",
    "apiSign": "bf436eb0563b4890ae0da215bf20c8ae",
    "is_new_encrypt": true,
    "sign": true
  },
  "withdraw_msg": {
    "url": "msg/withdraw_msg",
    "method": "post"
  },
  "ack_msg_batch": {
    "url": "msg/ack_msg_batch",
    "method": "post"
  },
  "ack_msg_read": {
    "url": "msg/ack_msg_read",
    "method": "post"
  },
  "ack_msg_show": {
    "url": "msg/ack_msg_show",
    "method": "post"
  },
  "get_session_list": {
    "url": "msg/get_session_list",
    "method": "get"
  },
  "get_specify_session_list": {
    "url": "msg/get_specify_session_list",
    "method": "post"
  },
  "get_chat_records": {
    "url": "msg/get_chat_records",
    "method": "get"
  },
  "get_unrecv_msgs": {
    "url": "msg/get_unrecv_msgs",
    "method": "get"
  },
  "get_captcha": {
    "url": "msg/get_captcha",
    "method": "get"
  },
  "validate_captcha": {
    "url": "msg/validate_captcha",
    "method": "get"
  },
  "get_session_unread_msg_count": {
    "url": "msg/get_session_unread_msg_count",
    "method": "get"
  },
  "exchange_xid": {
    "url": "common/js/exchange_xid",
    "method": "post"
  },
  "get_total_unread_msg_count": {
    "url": "msg/get_total_unread_msg_count",
    "method": "get"
  },
  "clear_all_unread_msgs":{
    "url":"msg/clear_all_unread_msgs",
    "method": "post"
  },
  "get_others_showed_count": {
    "url": "msg/get_others_showed_count",
    "method": "post"
  },
  "get_wostoken": {
    "url": "rich_text/get_wostoken",
    "method": "post"
  },
  "notify_hunter": {
    "url": "rich_text/notify_hunter",
    "method": "post"
  },
  "check_file": {
    "url": "rich_text/check_file",
    "method": "post"
  },
  "set_evaluation": {
    "url": "msg/set_evaluation",
    "method": "post"
  },
  "del_sessions": {
    "url": "msg/del_sessions",
    "method": "post"
  },
  "call": {
    "url": "msg/call",
    "method": "post"
  },
  "update_call": {
    "url": "msg/update_call",
    "method": "post"
  },
  "update_event": {
    "url": "msg/update_event",
    "method": "post"
  },
  "call_join_room": {
    "url": "join/",
    "method": "post",
    "api_type": "call"            // 音视频接口
  },
  "call_get_room": {
    "url": "room/getroomid",
    "method": "post",
    "api_type": "call"            // 音视频接口
  },
  "del_msg": {
    "url": "msg/delete_msg",
    "method": "post"
  },
  "create_group": {
    "url": "group/create_group",
    "method": "post"
  },
  "update_group": {
    "url": "group/update_group",
    "method": "post"
  },
  "disband_group": {
    "url": "group/disband_group",
    "method": "post"
  },
  "apply_join_group": {
    "url": "group/apply_join_group",
    "method": "get"
  },
  "invite_join_group": {
    "url": "group/invite_join_group",
    "method": "post"
  },
  "accept_join_group_apply": {
    "url": "group/accept_join_group_apply",
    "method": "post"
  },
  "accept_join_group_invite": {
    "url": "group/accept_join_group_invite",
    "method": "post"
  },
  "manage_group_member": {
    "url": "group/manage_group_member",
    "method": "post"
  },
  "quit_group": {
    "url": "group/quit_group",
    "method": "get"
  },
  "transfer_group_owner": {
    "url": "group/transfer_group_owner",
    "method": "post"
  },
  "get_group_member": {
    "url": "group/get_group_member",
    "method": "post"
  },
  "get_group_member_byid": {
    "url": "group/get_group_member_byid",
    "method": "post"
  },
  "get_group_info": {
    "url": "group/get_group_info",
    "method": "post"
  },
  "set_slient": {
    "url": "group/set_slient",
    "method": "post"
  },
  "accept_join_group": {
    "url": "group/accept_join_group",
    "method": "post"
  },
  "confirm_invite": {
    "url": "group/confirm_invite",
    "method": "post"
  },
  "get_qrcode_id": {
    "url": "group/get_qrcode_id",
    "method": "post"
  },
  "get_qrcode_info": {
    "url": "group/get_qrcode_info",
    "method": "post"
  },
  "report_msg": {
    "url": "msg/reportmsg",
    "method": "post"
  },
  "ack_contactinfo":{ //索取用户名片
    "url":"user/ask_contactinfo",
    "method": "get"
  },
  "provide_contactinfo":{//提供用户名片
    "url":"user/provide_contactinfo",
    "method": "post"
  },
  "glance_contactinfo":{//查看用户名片
    "url":"user/glance_contactinfo",
    "method": "get"
  },
  "get_self_contactinfo":{//获取自己的名片信息
    "url":"user/get_self_contactinfo",
    "method": "get"
  },
  "get_forward_msg":{//获取转发消息内容
    "url":"msg/get_forward_msg",
    "method": "post"
  },
  "collection":{//提供用户名片
    "url":"msg/collection",
    "method": "post"
  },
  "del_collection":{//提供用户名片
    "url":"msg/del_collection",
    "method": "post"
  },
  "get_collection":{//提供用户名片
    "url":"msg/get_collection",
    "method": "post"
  },
  "set_template_msg":{//设置匿名消息模版
    "url":"im/settemplatemsg",
    "method": "post"
  },
  "get_template_msg":{//获取匿名消息模版
    "url":"im/gettemplatemsg",
    "method": "post"
  },
  "update_template_msg":{//更新匿名消息模版
    "url":"im/updatetemplatemsg",
    "method": "post"
  },
  "delete_template_msg":{//删除匿名消息模版
    "url":"im/deletetemplatemsg",
    "method": "post"
  },
  "add_notice_task": { // 新增提醒任务
    "url": "user/add_notice_task",
    "method": "post"
  },
  "update_notice_task": {   // 修改提醒任务
    "url": "user/update_notice_task",
    "method": "post"
  },
  "get_notice_task_batch": { // 分页拉取提醒任务
    "url": "user/get_notice_task_batch",
    "method": "post"
  },
  "merge_user": { // 合并用户信息
    "url": "user/merge_user",
    "method": "get"
  },
  'get_pic_upload_url': { // 获取图片上传接口鉴权
    'url': 'msg/get_pic_upload_url',
    'method': 'post'
  }
};

for (var key in conf) {
  if (conf.hasOwnProperty(key)) {
    conf[key].name = key;
  }
}

module.exports = conf;
